import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginSuccess from "./pages/Loginsuccess";
import DashboardLayout from "./pages/DashboardLayout";
import Event from "./pages/Event";
import Foryou from "./pages/Foryou";
import Settings from "./pages/Settings";
import Sell from "./pages/Sell";

import { AuthProvider, useAuth } from "./context/AuthContext";

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

function AppRoutes() {
  const { user, loading, networkError } = useAuth();

  if (loading) {
    // return <div style={{ padding: 20 }}>Checking session...</div>;
    return <LoginSuccess />;
  }

  if (networkError && user) {
    return (
      // <div style={{ padding: 20, color: "red" }}>
      //   No internet connection. You're logged in, but we couldn't verify your
      //   session. Please check your connection and reopen the app.
      // </div>
      <LoginSuccess />
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        element={user ? <Navigate to="/login-success" replace /> : <Login />}
      />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="discover" element={<Dashboard />} />
        <Route path="event" element={<Event />} />
        <Route path="foryou" element={<Foryou />} />
        <Route path="settings" element={<Settings />} />
        <Route path="sell" element={<Sell />} />
      </Route>

      <Route path="/login-success" element={<LoginSuccess />} />
      <Route path="/login" element={<Login />} />
    </Routes>
  );
}

export default App;
